import { LocalStorage } from 'libs/common';
import { Draggable } from 'libs/ui';
import { ZoneRow } from './zone-row/zone-row';
import { Content, Name, Zones } from './counter.styled';

const storage = new LocalStorage('counters');

window.lastCounterY = 30;
window.lastCounterH = 0;
window.lastCounterBlockX = 0;

// два столбца карточек занимают 267 + 247 px, плюс зазор до следующей пары столбцов
const BLOCK_W = 534;
const BOTTOM_GAP = 15;

// высота области, в которой раскладываем карточки (низ экрана)
const getAreaHeight = () => document.querySelector('.app-content')?.clientHeight || window.innerHeight;

export const Counter = (props) => {
  const { index, data, scale, ...rest } = props;
  const { client_name, client_id } = data;
  const wide = client_id !== 'oneTimeAll' && client_id !== 'regularAll';

  // const node = window.config.objects.zones.find((item) => {
  //   return item.zoneId.toString() === window.zone_id.toString();
  // });

  const getCoord = () => {
    const saved = storage.getItem(client_id);
    // console.log("🚀 ~ getCoord ~ saved:", saved)
    if (saved) {
      return saved;
    }
    if (index === 0) {
      window.lastCounterY = 30;
      window.lastCounterH = 0;
      window.lastCounterBlockX = 0;
    }
    const odd = index % 2;
    const own = data.items.length * 20 + 14 + 15 + 15;
    const h = Math.max(own, window.lastCounterH);
    // новая пара столбцов — при достижении низа экрана переносим на следующие 2 столбца
    if (!odd && window.lastCounterY > 30 && window.lastCounterY + own > getAreaHeight() - BOTTOM_GAP) {
      window.lastCounterBlockX += BLOCK_W;
      window.lastCounterY = 30;
    }
    const x = (odd ? 0 : 267) + window.lastCounterBlockX;
    const y = window.lastCounterY;
    if (odd) {
      window.lastCounterY += h;
    }
    window.lastCounterH = odd ? 0 : own;
    storage.setItem(client_id, { x, y });
    return { x, y };
  };

  const getItemsEl = () => {
    return data.items.map((el, idx) => <ZoneRow key={idx} {...el} />);
  };

  const setCoord = (_event, el) => {
    // console.log('🚀 ~ setCoord ~ event:', el);
    const { x, y } = el;
    storage.setItem(client_id, { x, y });
  };

  const { x, y } = getCoord();
  // console.log('🚀 ~ Counter ~ x, y:', x, y, client_id);
  const itemsEl = getItemsEl();

  return (
    <Draggable defaultPosition={{ x, y }} scale={scale} onStop={setCoord} width={wide ? '247px' : '165px'}>
      <Content {...rest} style={{ width: wide ? '247px' : '165px' }}>
        <Name title={client_name}>{client_name}</Name>
        <Zones>{itemsEl}</Zones>
      </Content>
    </Draggable>
  );
};
